import { ButtonHTMLAttributes, FC, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'destructive';
export type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Full width, for stacked phone layouts. */
  block?: boolean;
  children: ReactNode;
};

function classes(...values: (string | false | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}

/**
 * The one button.
 *
 * Height, padding, radius, colours, hover, focus and disabled come from
 * tokens and this file. A page passing className may place it, size it in a
 * grid or stretch it - but not restate its visual contract.
 */
const Button: FC<ButtonProps> = ({ variant = 'secondary', size = 'md', block = false, className, children, ...rest }) => (
  <button
    type="button"
    {...rest}
    className={classes(
      'ui-button',
      'ui-button--' + variant,
      size === 'md' ? undefined : 'ui-button--' + size,
      block && 'ui-button--block',
      className
    )}
  >
    {children}
  </button>
);

export default Button;
